// Centralised exchange rate constants.
// Last updated: June 2026. Update when rates shift >2%.
export const NGN_PER_USD = 1590; // Nigerian Naira per US Dollar (was 1715)
export const USD_TO_CNY = 7.24;  // US Dollar to Chinese Yuan
export const USD_TO_EUR = 0.92;  // US Dollar to Euro
export const USD_TO_GBP = 0.79;  // US Dollar to British Pound

/** When the constants above were last reviewed; shown beside any amount converted with them. */
export const FIXED_RATES_AS_OF = 'June 2026';
